import React, { Component } from 'react'
import { Form, Table, Input, Row, Col, Modal, DatePicker } from 'antd'
import moment from 'moment'
import '_src/common/style/common.less' 
import { signList } from '_src/api/api'

const { RangePicker } = DatePicker
const { Search } = Input
@Form.create({ name: '' })
class SignList extends Component {
  constructor (props) {
    super(props)
    this.id = ''
    this.param = {
      mobile: '',
      nickname: '',
      pageNum: 0,
      createStart: '',
      createEnd: '',
      totalElements: 0
    }
    this.state = {
      loading: true,
      dataList: []
    }
  }

  componentDidMount () {
    this.loadData()
  }

  loadData () {
    this.setState({loading: true})
    const { pageNum, mobile, createStart, createEnd, nickname } = this.param
    let param = {pageNum, pageSize: 10}
    if (!!mobile) {
        param = {...param, mobile}
    }
    if (!!nickname) {
        param = {...param, nickname}
    }
    if (!!createStart&&!!createEnd) {
        param = {...param, createStart, createEnd}
    }
    signList(param).then( res => {
        const data = res.data.content
        this.param.totalElements = res.data.totalElements
        const dataList = data.map(item=>{
            return {mobile:item.user.mobile,nickname:item.user.nickname,nowSignDays:item.nowSignDays,daysCount:item.daysCount,key:item.id}
        })
        this.setState({
            loading: false,
            dataList: dataList
        })
    }).catch( err => {
        console.log(err)
    })
  }
  
  columns = () => {
    return [
      {
        title: <span>用户账号</span>,
        align: 'center',
        dataIndex: 'mobile',
      },

      {
        title: <span>用户昵称</span>,
        align: 'center',
        dataIndex: 'nickname',
      },     

      {
        title: <span>连续签到</span>,
        align: 'center',
        dataIndex: 'nowSignDays',
      },
      {
        title: <span>签到次数</span>,
        align: 'center',
        dataIndex: 'daysCount',
      }
    ]
  }

  // 条件搜索
  handleSearch = (key, value) => {
    this.param[key] = value
    this.param.pageNum = 0
    this.loadData()
  }

  //时间选择
  timerChange = (e) => {
    this.param.pageNum = 0
    this.param.createStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
    this.param.createEnd = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    this.loadData()
  }

  // 分页
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }

  render () {
    const { dataList, loading } = this.state
    const { pageNum, totalElements } = this.param
    return (
      <div className = "ReturnForm page_content" >
        <Form className = "goodlist_from">
          <div style = {{maxWidth: 900}}>
            <Row gutter = {24}>
              <Col span = {8}>
                <Form.Item label = "用户账号">
                  <Search placeholder="请输入用户账号" onSearch={(v)=>{ this.handleSearch('mobile', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "用户昵称">
                  <Search placeholder="请输入用户昵称" onSearch={(v)=>{ this.handleSearch('nickname', v) }} enterButton />
                </Form.Item>
              </Col>
              <Col span = {8}>
                <Form.Item label = "注册时间">
                  <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        <Table
          loading = {loading} 
          bordered
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (pageNum + 1),
            total: totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
      </div>
    )
  }
}

export default SignList